import { Component } from '@angular/core';
import { AuthService } from '../../Services/auth.service';

@Component({
  selector: 'app-business-insights',
  standalone: false,
  templateUrl: './business-insights.component.html',
  styleUrl: './business-insights.component.css'
})
export class BusinessInsightsComponent {
menuItems = [
  { path: "MarketTrends", label: "MENU.MARKET_TRENDS" },
  { path: "Competitiveint", label: "MENU.COMPETITIVE_INTELLIGENCE" },   
  ];
userRole:string
constructor(private auth:AuthService){
    this.userRole=this.auth.getRoles();
}

getIcon(path: string): string {
  const iconMap: { [key: string]: string } = {
    "MarketTrends": "fas fa-chart-bar",  
    "Competitiveint": "fas fa-user-secret", 
  };
  return iconMap[path] || "bi bi-circle"; 
}
}
